{
	"title": "Nie znaleziono transakcji",
	"description": "Przejdź do przeglądu i wprowadź prawidłowy identyfikator transakcji. Identyfikator transakcji można znaleźć na deklaracji lub na fakturze.",
	"secondaryButtonTitle": "Pokaż stronę startową"
}
